<template>
    <div 
        v-if="current"
        class="question-counter"
    >
        <span class="question-counter__current-question">Vraag {{ current }}</span>
        <span
            v-if="total"
            class="question-counter__total"
        > van {{ total }}</span>
    </div>
</template>

<script setup>
defineProps({
    current: {
        type: Number,
        default: null
    },
    total: {
        type: Number,
        default: null
    }
});
</script>

<style lang="less">
    .question-counter {
        .typography-label();
    }

    .question-counter__total {
        opacity: .6;
    }
</style>